"use client";
import Link from "next/link";
import { urls } from "../urls/Urls";

const Header = () => {
  return (
    <div className="w-full pb-2 flex flex-col sm:flex-row items-center justify-between text-white">
      <Link href="/">
        <div className="">
          <img
            src="/gc_logo.png"
            className="h-14 md:h-20 w-full p-2 md:p-4 hidden sm:block"
            alt="Company logo"
          />
        </div>
      </Link>

      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-row sm:flex-row z-0 w-fit">
          <img
            src="/help2.png"
            height={100}
            width={100}
            className="z-0 -ml-12"
            alt="help logo"
          />
          <h1 className="sm:text-6xl text-5xl flex items-center justify-center text-center font-medium text-white font-trade-gothic">
            GC Help
          </h1>
        </div>
        <p className="sm:text-2xl text-xl text-white text-center">
          How can we help?
        </p>
      </div>

      <div className="flex flex-row items-center">
        <div className="flex flex-row font-sans text-center gap-x-4 p-6">
          <div>
            <a href={urls.mytickets} target="_blank">
              <button
                className="h-12 w-42 items-center bg-[#be9729] hover:bg-[#a98624] text-white p-1 flex flex-row rounded"
                title="My Technology Solutions Tickets"
              >
                <img
                  src="/ticket.png"
                  height={40}
                  width={40}
                  className=""
                  alt="ticket"
                />
                <p className="text-base p-2 font-medium truncate">
                  My TS Tickets
                </p>
              </button>
            </a>
          </div>

          <div>
            <a href={urls.knowledge} target="_blank">
              <button
                className="h-12 w-42 items-center hover:bg-[#a98624] p-1 flex flex-row rounded"
                title="Knowledge Center"
              >
                <img
                  src="/knowledge.png"
                  height={38}
                  width={38}
                  className=""
                  alt="ticket"
                />
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
